module.exports = __webpack_public_path__ + "static/media/on2.023a9f15.png";